<template>
  <modal v-model="showMRONeededBenefitsModal" effect="fade" :large="true" :backdrop="false">
    <div slot="modal-header" class="modal-header">
      <strong class="modal-title">145 Approved MRO Needed Benefits - Comparison Chart</strong>
    </div>
    <div slot="modal-body" class="modal-body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="3"></th>
            <th colspan="3">MRO Type</th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <th scope="col">Benefits</th>
            <th scope="col">LMSA</th>
            <th scope="col">PLA-LM</th>
            <th scope="col">GSL-LM</th>
            <th scope="col">PLA-CR</th>
            <th scope="col">GSL-CR</th>
            <th scope="col">PLA-OH</th>
            <th scope="col">GSL-OH</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="col">Spare Parts & Tooling</th>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
          <tr>
            <th scope="row">Training</th>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td></td>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
          <tr>
            <th scope="row">Tech Pubs - Engine Manuals</th>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
          <tr>
            <th scope="row">Tech Pubs - AMM Only</th>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th scope="row">Standard Technical Data - Engine Manuals</th>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
          <tr>
            <th scope="row">Standard Technical Data - AMM Only</th>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th scope="row">Access to Test Cell Correlation</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
          <tr>
            <th scope="row">Departure Record Support & Enginnering Inquiry Access</th>
            <td></td>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
            <td></td>
            <td><span class="fa fa-check-circle text-info fa-lg" /></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="modal-footer" class="modal-footer">
      <button type="button" class="btn btn-sm btn-primary" @click="closeModal">Close</button>
    </div>
  </modal>
</template>
<script>
import modal from "build-ui-x/src/Modal";

export default {
  name: "MRONeededBenefitsChart",
  components: {
    modal,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showMRONeededBenefitsModal: false,
    };
  },
  watch: {
    value(val) {
      this.showMRONeededBenefitsModal = val;
    },
  },
  methods: {
    closeModal() {
      this.$emit("input", false);
    },
  },
};
</script>
<style lang="less" scoped>
.modal-header {
  padding-bottom: 0;
}
.modal-body {
  padding-right: 25px;
  padding-top: 0;
  padding-bottom: 0;
  overflow-x: auto;
}
.modal-footer {
  padding-top: 0;
  padding-right: 25px;
}
.modal-title {
  color: #000;
  font-size: 25px;
  font-weight: 500;
}
.table > tbody > tr > th, .table > tbody > tr > td {
  border-right: 0.1px solid rgb(214, 228, 235);//#ADBDC6;
  border-top: none;
}
.table > tbody > tr > th:first-child, .table > tbody > tr > td:last-child{
  border-right: none;
}
.table > tbody > tr > td {
  text-align: center;
  width: 95px;
  height: 45px;
  vertical-align: middle;
}
.table > tbody > tr > th {
  text-align: right;
  background-color: white;
  font-weight: normal;
  vertical-align: middle;
  padding-top: 0;
  padding-bottom: 0;
}
.table > thead > tr > th:nth-child(1) {
  text-align: right;
  font-weight: bold;
  color: #000;
  padding-bottom: 0px;
  text-transform: capitalize;
  font-size: 15px;
}
.table > thead:first-child > tr:first-child > th {
  color: #000;
  text-transform: capitalize;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
}
.table > thead > tr > th {
  border: none !important;
}
.table > thead > tr:nth-child(2) {
  height: 50px;
}
.table > thead > tr:nth-child(2) > th:not(:first-child) {
  vertical-align: middle;
  text-align: center;
  font-weight: bold;
  background-color: black;
  color: white;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: rgb(228, 237, 242);
}
.table-striped > tbody > tr:nth-of-type(even) {
  background-color: rgb(239, 244, 247);
}
</style>
